import { FC } from 'react';
import { useAdminCompanies } from 'store/admin-companies';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
> & { clientId: string };

export const AdminCompaniesFilter: FC<Props> = ({ clientId, ...props }) => {
  const { data: companies, isLoading } = useAdminCompanies(clientId);

  return (
    <SelectFilter
      {...props}
      options={companies?.items.map((company) => ({
        key: company.id,
        label: company.name,
      }))}
      loadingOptions={isLoading}
      multiple
    />
  );
};
